import { Clickable, H2, theme } from '@ahmdigital/ui';
import styled from 'styled-components';

const { colors, fontFamilies, media } = theme;

const BORDER_THICKNESS = '1px';

export const StyledClickable = styled(Clickable)`
  font-weight: 600;
  margin-top: 1.5rem;
`;

export const StyledHeading = styled(H2)`
  margin-bottom: 1rem;

  @media (min-width: ${media.md}) {
    margin-bottom: 1.5rem;
  }
`;

export const StyledDayPickerWrapper = styled.div`
  @media (min-width: ${media.md}) {
    max-width: 37rem;
  }

  .rdp-root {
    --rdp-accent-color: unset;
    --rdp-selected-border: unset;
    --rdp-accent-background-color: unset;
    --rdp-day_button-border: unset;
    --rdp-day-width: 1rem;
    --rdp-font-family: ${fontFamilies.base};

    display: flex;
    justify-content: center;

    @media (min-width: ${media.md}) {
      --rdp-day-height: 1rem;
      display: unset;
      justify-content: unset;
      height: unset;
    }
  }
  .rdp-caption_label {
    font: 1rem ${fontFamilies.base};
    font-weight: 400;
  }
  .rdp-chevron {
    margin-left: 0.5rem;
  }
  .rdp-day {
    box-shadow: inset 0 0 0 ${BORDER_THICKNESS} ${colors.white};
  }
  .rdp-day_button {
    font: 1rem ${fontFamilies.base};
    padding: 1rem;

    @media (min-width: ${media.md}) {
      padding: 1.25rem;
    }
  }
  .rdp-dropdowns {
    gap: 1rem;
  }
  .rdp-month_caption {
    justify-content: flex-start;
  }
  .rdp-months {
    @media (min-width: ${media.sm}) {
      gap: 8rem;
    }
    @media (min-width: ${media.md}) {
      gap: 1.5rem;
    }
    @media (min-width: ${media.lg}) {
      gap: 2rem;
    }
  }
  .rdp-nav {
    gap: 1.5rem;
  }
  .rdp-weekday {
    color: ${colors.grey50};
    font-size: 1rem;
    font-weight: 400;
    opacity: 1;
  }
  .rdp-selected.rdp-range_middle {
    border-radius: 0;
    color: inherit;
    background-color: ${colors.purpleTint};
    box-shadow:
      inset 0 ${BORDER_THICKNESS} 0 0 ${colors.purple},
      inset 0 -${BORDER_THICKNESS} 0 0 ${colors.purple};

    font-weight: unset;
  }
  .rdp-today {
    box-shadow: inset 0 0 0 ${BORDER_THICKNESS} ${colors.purple};
    border-radius: 0.5rem;
  }
  .rdp-range_start,
  .rdp-range_end,
  .rdp-selected {
    background-color: ${colors.purple};
    border-radius: 5px;
    box-shadow: inset 0 0 0 ${BORDER_THICKNESS} ${colors.purple};
    color: ${colors.white};
    font-size: 16px;
  }

  .rdp-week,
  .rdp-weekdays {
    background-color: ${colors.white};
  }

  th,
  td {
    background-color: ${colors.white};
    border-bottom: unset;
    padding: 0;
  }

  tr {
    height: 2rem;
  }
  th:first-child {
    color: ${colors.grey50};
    font-weight: 400;
    font-size: unset;
    opacity: 1;
    text-align: center;
  }
  table {
    border-collapse: separate;
    border-spacing: 0 1rem;
  }
`;
